import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import { ATTACHMENTS_HANDLER_CONFIG } from '../config/attachments-handler.config';
import { SKIP_ERROR_TOAST } from '../http/http-context-tokens';


export interface StatusValidationResult {
    status: string;
    message: string;
    missing_items: string[];
}

function isValidationResult(value: unknown): value is StatusValidationResult {
    return !!value && typeof value === 'object' && Array.isArray((value as StatusValidationResult).missing_items);
}

export interface StatusResponse {
    status: string;
    state: string;
}

export const STATUS_LOCKED = 'locked';

@Injectable({ providedIn: 'root' })
export class StatusService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(ATTACHMENTS_HANDLER_CONFIG).apiUrl;

    getStatus(type: string, id: number): Observable<StatusResponse> {
        const context = new HttpContext().set(SKIP_ERROR_TOAST, true);
        return this.http.post<StatusResponse>(`${this.baseUrl}status`, {
            sourcemodel_type: type,
            sourcemodel_id: id,
        }, { context });
    }

    validate(type: string, id: number): Observable<StatusValidationResult> {
        const context = new HttpContext().set(SKIP_ERROR_TOAST, true);
        return this.http.post<StatusValidationResult>(`${this.baseUrl}status/validate`, {
            sourcemodel_type: type,
            sourcemodel_id: id,
        }, { context }).pipe(
            // A backend hiányzó társítások esetén 422-vel jelez, de a törzs ugyanaz a
            // validációs eredmény — ezt sikeres értékként továbbítjuk, nem hibaként.
            catchError((err: HttpErrorResponse) =>
                isValidationResult(err.error) ? of(err.error) : throwError(() => err),
            ),
        );
    }

    lock(type: string, id: number): Observable<unknown> {
        return this.http.post(`${this.baseUrl}status/lock`, {
            sourcemodel_type: type,
            sourcemodel_id: id,
        });
    }

    unlock(type: string, id: number): Observable<unknown> {
        return this.http.post(`${this.baseUrl}status/unlock`, {
            sourcemodel_type: type,
            sourcemodel_id: id,
        });
    }
}
